export default "/_next/static/images/texture-2-248ff7ffb9d46adb5ae115504ad8c59e.png";